import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import VOICE_API_URL from 'utils/VoiceApiUrl'

export const getClientToken = (argObject = {}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.VOICE.GET_TOKEN_REQUEST,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${VOICE_API_URL}/token`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
          .then((payload) => {
            if (
                
              payload && payload.notOk
            ) {
              dispatch({
                type: ActionType.Voice.GET_TOKEN_FAILURE,
                payload,
                notOk: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.VOICE.GET_TOKEN_SUCCESS,
              payload,
              ...argObject,
            })
            resolve(payload)
          })
          .catch((error) => {
            dispatch({
              type: ActionType.VOICE.GET_TOKEN_FAILURE,
              payload: error,
              ...argObject,
            })
            reject(error)
          })
      })
      .catch((err) => {
        console.log(err)
      })
  })

export const getClientTokenSchema = (argObject = {}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.VOICE.GET_TOKEN_SCHEMA_REQUEST,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${VOICE_API_URL}/token/schema`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
          .then((payload) => {
            dispatch({
              type: ActionType.VOICE.GET_TOKEN_SCHEMA_SUCCESS,
              payload,
              ...argObject,
            })
            resolve(payload)
          })
          .catch((error) => {
            dispatch({
              type: ActionType.VOICE.GET_TOKEN_SCHEMA_FAILURE,
              payload: error,
              ...argObject,
            })
            reject(error)
          })
      })
      .catch((err) => {
        console.log(err)
      })
  })
